import { useGetRetailerNetworksForUserQuery } from '../../data-access/queries';

export const useRetailerNetworksForUser = (limit?: number) => {
  return useGetRetailerNetworksForUserQuery({
    variables: {
      filter: {},
      first: limit,
    },
  });
};
